import React, { useState, useEffect } from 'react';
import { Alert, AlertTitle, Button, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { getComplianceDashboardStatus } from '../../services/api';

function ComplianceDashboardAlert() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await getComplianceDashboardStatus();
        const data = res.data?.data || res.data || null;
        setStatus(data);
      } catch (err) {
        console.debug('Compliance dashboard status not available:', err.message);
        setStatus(null);
      } finally {
        setLoaded(true);
      }
    };
    fetchStatus();
  }, []);

  if (!loaded || !status) return null;

  // Use summary_lines from backend (per-month detail)
  const summaryLines = status.summary_lines || [];

  // Don't show if nothing to report at all
  if (!status.has_outstanding && summaryLines.length === 0) return null;

  return (
    <Alert
      severity="info"
      icon={<AssignmentIcon />}
      sx={{ mb: 3 }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => navigate('/compliance')}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Go to Compliance
        </Button>
      }
    >
      <AlertTitle>
        {status.total_outstanding > 0
          ? `Compliance: ${status.total_outstanding} item${status.total_outstanding !== 1 ? 's' : ''} need attention`
          : 'Compliance update'}
      </AlertTitle>
      {summaryLines.length > 0 && (
        <Box>
          {summaryLines.map((line, i) => (
            <Typography key={i} variant="body2">{line}</Typography>
          ))}
        </Box>
      )}
    </Alert>
  );
}

export default ComplianceDashboardAlert;
